import { SupportType } from "@faire/help-center-utils/lib/dateInTimeZone";
import { getSettingChatWorkingHours } from "@faire/help-center-utils/settings/getSettingChatWorkingHours";
import { getSettingPhoneWorkingHours } from "@faire/help-center-utils/settings/getSettingPhoneWorkingHours";
import { IHCMessengerWorkingHours } from "@faire/web-api--source/indigofair/helpcenter/IHCMessengerWorkingHours";
import invert from "lodash/invert";

type IFormattedWorkingHours = {
  formattedStartHours: string | undefined;
  formattedEndHours: string | undefined;
  formattedTimezone: keyof typeof TIMEZONE | undefined;
};

enum TIMEZONE {
  EST = "America/New_York",
  GMT = "Europe/London",
}

const formatTo12Hour = (hours: number) => {
  let adjustedHours = hours % 12;
  if (adjustedHours === 0) {
    adjustedHours = 12;
  }
  return `${adjustedHours}`;
};

// @ts-prune-ignore-next
export const getFormattedWorkingHours = ({
  start_at,
  end_at,
  timezone,
}: IHCMessengerWorkingHours): IFormattedWorkingHours => {
  if (!start_at || !end_at || !timezone) {
    return {
      formattedStartHours: undefined,
      formattedEndHours: undefined,
      formattedTimezone: undefined,
    };
  }
  const startHours = start_at / (1000 * 60 * 60);
  const endHours = end_at / (1000 * 60 * 60);
  const formattedStartHours = formatTo12Hour(startHours);
  const formattedEndHours = formatTo12Hour(endHours);

  const timezoneMap = invert(TIMEZONE);
  const formattedTimezone = timezoneMap[timezone] as keyof typeof TIMEZONE;

  return {
    formattedStartHours,
    formattedEndHours,
    formattedTimezone,
  };
};

export const getSupportWorkingHours = (supportType: SupportType) => {
  let workingHoursSetting;
  if (supportType === "chat") {
    workingHoursSetting = getSettingChatWorkingHours();
  } else {
    workingHoursSetting = getSettingPhoneWorkingHours();
  }
  return getFormattedWorkingHours(workingHoursSetting);
};
